const video = {
  init: () => {
    const postVideos = document.querySelectorAll('.page-template-page-single-news video, .default-page-box video');
    // postVideos.forEach((video) => {
    //   const videoCopy = video.cloneNode();
    //   const wrapper = document.createElement('div');
    //   wrapper.classList = 'video-wrap';
    //   const button = document.createElement('button');
    //   button.classList = 'video-play';
    //   wrapper.appendChild(button);
    //   wrapper.appendChild(videoCopy);
    //   video.parentNode.insertBefore(wrapper, video.nextSibling);
    //   video.remove();
    //   button.addEventListener('click', () => {
    //     button.classList.add('hide');
    //     videoCopy.play();
    //     videoCopy.controls = true;
    //   })
    // });
  },
  block: () => {
    const videoBlocks = document.querySelectorAll('.video-block');
    videoBlocks.forEach((videoBlock) => {
      const type = videoBlock.getAttribute('data-type');
      switch (type) {
        case 'file':
          initVideoFile(videoBlock);
          break;
        case 'yt':
          initVideoYoutube(videoBlock);
          break;
        default:
          return;
      }
    });

    function initVideoFile(videoBlock) {
      const video = videoBlock.querySelector('video');
      const button = videoBlock.querySelector('.video-play');
      const cover = videoBlock.querySelector('.video-block__cover');
      if (!video || !button) {
        return;
      }
      button.addEventListener('click', () => {
        if (cover) {
          cover.classList.add('hide');
        }
        video.play();
        video.controls = true;
      })
    }

    function initVideoYoutube(videoBlock) {
      const blockId = videoBlock.getAttribute('data-id');
      const button = videoBlock.querySelector('.video-play');
      const cover = videoBlock.querySelector('.video-block__cover');
      const ytUrl = videoBlock.querySelector(`#player-${blockId}`).getAttribute('data-url');
      if (!ytUrl) {
        return;
      }
      const ytId = getIdFromUrl(ytUrl);
      const startTime = getStartTime(ytUrl);
      const tag = document.createElement('script');
      tag.src = "https://www.youtube.com/iframe_api";
      const firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
      var player;

      function onYouTubeIframeAPIReady(id) {
        player = new YT.Player(`player-${id}`, {
          height: '360',
          width: '640',
          videoId: ytId,
          events: {
            'onReady': onPlayerReady,
            'onStateChange': onPlayerStateChange
          }
        });
      }
      setTimeout(function () {
        onYouTubeIframeAPIReady(blockId);
      }, 1000);

      function onPlayerReady(event) {
        button.addEventListener('click', () => {
          if (cover) {
            cover.classList.add('hide');
          }
          player.loadVideoById({
            'videoId': ytId,
            'startSeconds': startTime,
          })
        })
      }
      var done = false;

      function onPlayerStateChange(event) {
        if (event.data == YT.PlayerState.PLAYING && !done) {
          setTimeout(stopVideo, 6000);
          done = true;
        }
      }

      function stopVideo() {
        player.stopVideo();
      }

      function getIdFromUrl(url) {
        const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\/)|(\?v=|\&v=))([^#\&\?]*).*/;
        const match = url.match(regExp);
        return match[match.length - 1];
      }

      function getStartTime(url) {
        const regExp = /^.*?(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*)(?:(\?t|&start)=(\d+))?.*/;
        const match = url.match(regExp);
        return match[match.length - 1];
      }
    }
  }
}
export default video;